import { useEffect } from 'react';
import Lenis from 'lenis';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';
import { Navbar, scrollToSection } from '@/components/Navbar';
import { Hero } from '@/components/Hero';
import { Marquee } from '@/components/Marquee';
import { Collections } from '@/components/Collections';
import { Configurator } from '@/components/Configurator';
import { Manifesto } from '@/components/Manifesto';
import { Dealers } from '@/components/Dealers';
import { Contact } from '@/components/Contact';
import { Footer } from '@/components/Footer';
import { WhatsAppButton } from '@/components/WhatsAppButton';
import CollectionDetail from '@/components/CollectionDetail';
import AdminInbox from '@/components/AdminInbox';

const ScrollManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.085, wheelMultiplier: 1.05 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const Page = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
    <WhatsAppButton />
  </>
);

const HomePage = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo) {
      const t = setTimeout(() => scrollToSection(location.state.scrollTo), 400);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <Page>
      <Hero />
      <Marquee />
      <Configurator />
    </Page>
  );
};

function App() {
  return (
    <div className="App" data-testid="jakson-app">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/collections" element={<Page><div data-testid="collections-page" className="pt-10"><Collections /></div></Page>} />
          <Route path="/collections/:id" element={<Page><CollectionDetail /></Page>} />
          <Route path="/craft" element={<Page><div data-testid="craft-page" className="pt-10"><Manifesto /></div></Page>} />
          <Route path="/partners" element={<Page><div data-testid="partners-page" className="pt-10"><Dealers /></div></Page>} />
          <Route path="/contact" element={<Page><div data-testid="contact-page" className="pt-10"><Contact /></div></Page>} />
          <Route path="/admin" element={<AdminInbox />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
